import React from 'react'
import './Container.css'

const Container = (props) => {
  return (
    <div>
      {props.children}
    </div>
  )
}

export default Container
